import { ZoneFeature } from '../models/zones-base-interfaces'
import { authFetchGET } from '../utils/auth-fetch'

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;
const env = (<any>window).appenv
export class GeofencesService {
    static async fetchGeofenceByZone(type: string): Promise<ZoneFeature[]> {
        const baseURL = env.isLocal || isVesselOnCloud
            ? `${env.services.geofences.baseurl}/geofences/zone`
            : `${env.services.terminals.baseurl}/v1/terminals/geozones`
        return await authFetchGET(env.scope, `${baseURL}/${type}`)
    }
}
